var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"pb-6",staticStyle:{"min-height":"80% !important"}},[_c('AppMainCarousel'),_c('AppMainProducts')],1)}
var staticRenderFns = []

export { render, staticRenderFns }